import { render, staticRenderFns } from "./hirarki.vue?vue&type=template&id=dedda2e4&"
import script from "./hirarki.vue?vue&type=script&lang=js&"
export * from "./hirarki.vue?vue&type=script&lang=js&"
import style0 from "./hirarki.vue?vue&type=style&index=0&id=dedda2e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports